import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import "@radix-ui/themes/styles.css";
import { Theme } from "@radix-ui/themes";
import './App.css'
import App from './App.jsx'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import NotificationProvider from './components/common/NotificationContext.jsx'
import {ApiPopupProvider} from "./components/common/ApiPopup/ApiPopupProvider.jsx";

const queryClient = new QueryClient();


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
        <ApiPopupProvider>
      <NotificationProvider>
        <App />
      </NotificationProvider>
        </ApiPopupProvider>
    </QueryClientProvider>
  </StrictMode>,
)
